import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-package-children',
  templateUrl: './package-children.component.html',
  styleUrls: ['./package-children.component.css']
})
export class PackageChildrenComponent implements OnInit {

  childrenData: any[] = [];
  columns: any[] = [
    { name: "instanceId", displayName: "Instance Id" },
    { name: "packageId", displayName: "Package Id" },
    { name: "medicine", displayName: "Medicine" }
  ];

  totalCount: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.childrenData = this.data.childrenData;
      this.totalCount = this.childrenData.length;
    }, 200);
  }

}
